import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
  blackColor,
  hexToRgb,
} from "assets/jss/material-dashboard-react.js";
import modalStyle from "assets/jss/material-dashboard-react/modalStyle.js";
import brandTheme from "brandTheme/Theme";

const styles = (theme) => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "0px",
    },
  },
  radio: {
    "&$checked": {
      color: "#2391d2",
    },
  },
  checked: {},
  loginMaxWidth: {
    maxWidth: 380,
  },
  modalContainer: {
    fontWeight: 400,
    maxWidth: 1800,
  },
  walletContainer: {
    backgroundColor: "#EEEAEB",
    paddingLeft: "30px !important",
    paddingRight: "30px !important",
    paddingBottom: "30px !important",
  },
  heading: {
    fontFamily: "Poppins",
    fontSize: "xx-large",
    fontWeight: 500,
    marginBottom: 20,
    padding: 13,
  },
  tableContainer: {
    textAlign: "left",
    margin: "10px 0px",
    padding: 10,
    width: "auto",
    border: "1px solid #C1C1C1",
    borderRadius: 5,
    overflow: "hidden",
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  },
  accordianContainer: {
    marginBottom: "20px !important",
    border: "1px solid #C1C1C1",
    borderRadius: 10,
  },
  accordianHeading: {
    fontSize: "x-large",
    fontWeight: 500,
    fontFamily: "Poppins",
  },
  content: {
    fontWeight: 400,
    fontSize: 16,
  },
  floatLeft: {
    float: "left",
  },
  floatRight: {
    float: "right",
  },
  floatNone: {
    float: "none",
  },
  alignLeft: {
    textAlign: "left",
  },
  alignRight: {
    textAlign: "right",
  },
  detailsHeader: {
    textAlign: "left",
    marginBottom: 20,
    fontSize: 18,
  },
  detailsRow: {
    marginTop: 10,
    color: "black",
    paddingRight: 15,
  },
  buttonContainer: {
    marginTop: 20,
    marginBottom: 20,
  },
  detailsRowFooter: {
    fontSize: 12,
    textAlign: "left",
  },
  button: {
    marginLeft: 20,
  },
  checkIcon: {
    color: "#A5DC86",
    border: "solid 4px",
    borderRadius: 22,
    padding: 2,
    fontSize: 44,
    borderColor: "aquamarine",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  titleContent: {
    paddingTop: 5,
    paddingLeft: 10,
    fontSize: "xx-large",
  },
  loginModalTitle: {
    fontWeight: 600,
    textAlign: "left",
  },
  subTitle: {
    fontWeight: 400,
    fontSize: "16px",
  },
  center: {
    textAlign: "center",
    margin: 20,
    marginTop: 40,
  },
  cardTitle: {
    ...cardTitle,
    marginTop: "0",
    marginBottom: "3px",
    color: grayColor[2],
    fontSize: "18px",
  },
  labelStyle: {
    color: grayColor[1] + " !important",
    fontSize: 14,
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 400,
    lineHeight: 1.42857,
    textAlign: "left",
    transform: "none",
  },
  cardSubtitle: {
    color: grayColor[0],
    fontSize: 14,
    margin: "0 0 10px",
  },
  textCenter: {
    textAlign: "center",
  },
  justifyContentCenter: {
    justifyContent: "center !important",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  inputAdornmentIcon: {
    borderRadius: 10,
    height: 32,
    backgroundColor: grayColor[0],
    opacity: 0.5,
    color: "#505050",
    marginLeft: "-47px",
    "&:hover": {
      backgroundColor: grayColor[0],
      opacity: 0.9,
    },
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  cardHeader: {
    marginBottom: "20px",
    zIndex: "3",
  },
  socialLine: {
    padding: "0.9375rem 0",
  },
  menuPaper: {
    height: "100px !important",
  },
  menu2Paper: {
    height: "250px !important",
  },
  mt0: {
    marginTop: "0px !important",
  },
  mt10: {
    marginTop: "10px !important",
  },
  serachicon: {
    // border: "1px",
    // boxShadow:"1px 3px 1px #9E9E9E"
    position: "absolute",
    zIndex: 2,
    display: "block",
    width: "2.375rem",
    height: "2.375rem",
    lineHeight: "2.375rem",
    textAlign: "center",
    pointerEvents: "none",
    color: " #aaa",
    paddingLeft: "2.375rem",
  },
  disabled: {
    backgroundColor: "rgb(0,0,0,0.1)",
  },
  tableHeader: {
    backgroundColor: "rgb(0,0,0,0.1)",
    fontSize: 14,
    padding: 10,
    fontWeight: 500,
  },
  checkboxInput: {
    width: 15,
    height: 15,
    marginRight: 15,
  },
  tooltipCalculator: {
    padding: "2px 10px",
    minWidth: "100px",
    maxWidth: "400px",
    color: blackColor,
    lineHeight: "1.2em",
    background: "#FFFFF0",
    border: "none",
    borderRadius: "3px",
    opacity: "1!important",
    boxShadow:
      "0 8px 10px 1px rgba(" +
      hexToRgb(blackColor) +
      ", 0.14), 0 3px 14px 2px rgba(" +
      hexToRgb(blackColor) +
      ", 0.12), 0 5px 5px -3px rgba(" +
      hexToRgb(blackColor) +
      ", 0.2)",
    textAlign: "center",
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    textShadow: "none",
    textTransform: "none",
    letterSpacing: "normal",
    wordBreak: "normal",
    wordSpacing: "normal",
    wordWrap: "normal",
    whiteSpace: "normal",
    lineBreak: "auto",
  },
  nextButton:{
    boxShadow:'inherit',
    color:brandTheme.white,
   margin:"10px 10px 10px 0 ",
   letterSpacing:"1px",
    height:"40px",
    // width:"8%",
    padding:'0px 40px',
    width:"100px",
    backgroundColor:brandTheme.buttonColor,
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    },
    '&:focus':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  },
  nextButton1:{
    boxShadow:'inherit',
    color:brandTheme.white,
   margin:"10px 10px 10px 0 ",
    padding:'0px 40px',
    height:"40px",
    // width:"8%",
    width:"100px",
    backgroundColor:brandTheme.button2Color,
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    },
    '&:focus':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  },
  ...modalStyle(theme),
});

export default styles;
